import React from "react";
import { useForm } from "react-final-form";

import {
    ReferenceInput,
    TextInput,
    AutocompleteInput,
    NumberInput,
    BooleanInput,
    required,
} from "react-admin"

import {
    TableCell,
    TableRow,
} from "@material-ui/core";

export const PhagesHostsExternalFields = (props) => {
    const index = props.index;
    const DeleteButton = props.deleteButton;
    const form = useForm();
    var formdata = form.getState().values;
    const values = formdata.phages_hosts;
    let isExternal= values[index].is_external_isolate;
    if (isExternal) {
        return (<TableRow
            key={index}
            sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
        >

            <TableCell component="th" scope="row">

                <ReferenceInput
                    label="External Isolates"
                    source={`${props.source ?? 'phages_hosts'}[${index}].id_external_isolate`}
                    reference="external_isolates"
                    validate={required()}
                    filter={{ is_external_isolate: true }}
                >
                    <AutocompleteInput
                        resettable={true}
                        clearAlwaysVisible={true}
                        optionText="code"
                        shouldRenderSuggestions={(value) => value.trim().length > 1}
                        suggestionLimit={10}
                    />
                </ReferenceInput>
            </TableCell>
            <TableCell align="left">
                <NumberInput
                    label="Concentration"
                    source={`${props.source ?? 'phages_hosts'}[${index}].concentration`} />
            </TableCell>
            <TableCell align="left">
                <NumberInput
                    label="Quantificaction"
                    source={`${props.source ?? 'phages_hosts'}[${index}].quantification`}
                />
            </TableCell>
            <TableCell align="left">
                <BooleanInput
                    label="Kills"
                    source={`${props.source ?? 'phages_hosts'}[${index}].kills`}
                />
            </TableCell>
            <TableCell align="left">
                <TextInput
                    label="Intensity"
                    source={`${props.source ?? 'phages_hosts'}[${index}].intensity`}
                />
            </TableCell>
            <TableCell align="left">
                <TextInput
                    label="Susceptibility"
                    source={`${props.source ?? 'phages_hosts'}[${index}].susceptibility`}

                />
            </TableCell>
            <TableCell align="left">
                <TextInput
                    label="Notes"
                    source={`${props.source ?? 'phages_hosts'}[${index}].notes`} />
            </TableCell>

            <DeleteButton index={index}></DeleteButton>
        </TableRow>);
    }
    return (null);
}